import { Link } from "react-router-dom";
import { brand, contact, media } from "@/config/site";
import MediaImage from "@/components/feature/MediaImage";

const sectionLinks = [
  { label: "Hizmetler", to: "/#hizmetler" },
  { label: "Gelin Hazırlığı", to: "/#gelin" },
  { label: "Çalışmalarımız", to: "/#calismalarimiz" },
  { label: "Hikâyemiz", to: "/#hikayemiz" },
  { label: "İletişim", to: "/#iletisim" },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="px-4 py-14 md:px-6 md:py-16">
        <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-3">
              <span className="flex h-14 w-14 items-center justify-center overflow-hidden rounded-full bg-background-50/10">
                <MediaImage
                  src={media.logo}
                  alt="gülaYonar logosu"
                  objectPosition="object-center"
                  className="h-full w-full"
                />
              </span>
              <span className="font-heading text-3xl text-background-50">gülaYonar</span>
            </Link>
            <p className="mt-3 text-sm uppercase tracking-[0.2em] text-accent-400">
              {brand.tagline}
            </p>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-background-200/80">
              {brand.storyTitle}
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-lg text-background-50">Bölümler</h4>
            <ul className="mt-4 space-y-3">
              {sectionLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-background-200/80 transition-colors hover:text-accent-400"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-lg text-background-50">İletişim</h4>
            <ul className="mt-4 space-y-3 text-sm text-background-200/80">
              <li className="flex items-start gap-3">
                <span className="mt-0.5 flex h-5 w-5 items-center justify-center text-accent-400">
                  <i className="ri-map-pin-line" aria-hidden="true"></i>
                </span>
                <span>{contact.address}</span>
              </li>
              <li>
                <a
                  href={contact.phoneHref}
                  className="flex items-center gap-3 transition-colors hover:text-accent-400"
                >
                  <span className="flex h-5 w-5 items-center justify-center text-accent-400">
                    <i className="ri-phone-line" aria-hidden="true"></i>
                  </span>
                  {contact.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={contact.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 transition-colors hover:text-accent-400"
                >
                  <span className="flex h-5 w-5 items-center justify-center text-accent-400">
                    <i className="ri-instagram-line" aria-hidden="true"></i>
                  </span>
                  @{contact.instagramHandle}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-2 px-4 py-5 text-center text-xs text-background-200/60 sm:flex-row md:px-6">
          <p>© {year} gülaYonar Hair • Beauty • Make Up. Tüm hakları saklıdır.</p>
          <p>{brand.location}</p>
        </div>
      </div>
    </footer>
  );
}